export const TOAST_SUCCESS_TYPE = "success";
export const TOAST_ERROR_TYPE = "error";
export const TOAST_WARNING_TYPE = "warning";
export const TOAST_INFO_TYPE = "info";
